﻿(function (angular) {
  "use strict";

  /*
   * This module extends default localstorage with enhancement to include the expiry date and can set objects
   * ex: sessionstorage.set(key, value, expireHours)
   * expireHours is an {int} with number of hours to stay alive
   */

  // eslint-disable-next-line no-magic-numbers
  var HOURS_TO_MS_MULTIPLIER = 1000 * 3600;

  angular.module("Toyota.Factories").factory("SessionStorage", [
    "$window",
    function ($window) {
      function haveSessionStorage() {
        var test = "sstest";
        try {
          sessionStorage.setItem(test, test);
          sessionStorage.removeItem(test);
          return true;
        } catch (e) {
          return false;
        }
      }

      return {
        set: function (key, value, expireHours) {
          if (!haveSessionStorage()) {
            return;
          }

          var expiryDate = null;
          var extVal = null;

          if (angular.isNumber(expireHours)) {
            expiryDate = Date.now() + HOURS_TO_MS_MULTIPLIER * expireHours;
          }

          if (typeof value === "object") {
            extVal = angular.extend({ expiry: expiryDate }, value);
          } else {
            extVal = {
              val: value,
              expiry: expiryDate,
            };
          }

          $window.sessionStorage.setItem(key, JSON.stringify(extVal));
        },
        get: function (key) {
          if (!haveSessionStorage()) {
            return null;
          }

          var val = $window.sessionStorage.getItem(key);

          if (val) {
            val = JSON.parse(val);
            if (val.expire) {
              var now = Date.now();

              // delete the key if it timed out
              if (val.expire < now) {
                $window.sessionStorage.removeItem(key);
                return null;
              }

              return val.val;
            }

            return val;
          }

          return null;
        },
        exists: function (key) {
          if (!haveSessionStorage()) {
            return false;
          }

          return $window.sessionStorage.getItem(key) !== null;
        },
        remove: function (key) {
          if (!haveSessionStorage()) {
            return false;
          }

          var val = $window.sessionStorage.getItem(key);
          if (val) {
            $window.sessionStorage.removeItem(key);
            return true;
          }

          return false;
        },
      };
    },
  ]);
})(window.angular);
